/* COMPONENT - c.11.01 - Wheelchair Selection */

export default class WheelchairModelOverlay {

  constructor(overlayOpenTrigger) {
    this.openOverlay(overlayOpenTrigger);
    this.closeOverlay();
  }

  openOverlay(overlayOpenTrigger) {
    const overlays = document.querySelectorAll('.js-overlay');
    const overlayTriggerArray = Array.prototype.slice.call(overlayOpenTrigger);
    const overlaysArray = Array.prototype.slice.call(overlays);

    let overlayOpenTriggerVal;
    let overlaysVal;

    //Find matching trigger/overlay attribute on click and open the overlay
    overlayTriggerArray.forEach(function(el) {
      el.addEventListener('click', (e) => {
        e.preventDefault();

        document.documentElement.classList.add('js-overlay-active');

        overlayOpenTriggerVal = e.target.getAttribute('data-trigger-value');

        for (const overlay of overlaysArray) {
          overlaysVal = overlay.getAttribute('data-linked-value');

          if (overlaysVal === overlayOpenTriggerVal) {
            overlay.classList.add('js-show');
          } else {
            overlay.classList.remove('js-show');
          }   
        }
      });
    });
  }

  closeOverlay() {
    const overlayCloseTrigger = document.querySelectorAll('.js-close-overlay');
    const overlayCloseArray = Array.prototype.slice.call(overlayCloseTrigger);
    
    
    //Close current overlay on click
    overlayCloseArray.forEach(function(el) {
      el.addEventListener('click', (e) => {
        e.preventDefault();

        if (el.parentElement.closest('.js-overlay').classList.contains('js-show')) {
          document.documentElement.classList.remove('js-overlay-active');
          el.parentElement.closest('.js-overlay').classList.remove('js-show');
        } 
      });
    });
  }
}
